import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import { createWorkspace, updateWorkspace } from "../../redux/Slice/Workspace/workspaceSlice";

const WorkspaceDialog = ({ open, onClose, mode, workspace }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setFormData({ name: mode === "edit" && workspace ? workspace.name || "" : "" });
    setError("");
  }, [mode, workspace, open]);

  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
    setError("");
  };

  const handleClose = () => {
    setError("");
    onClose();
  };

  // A workspace is just a name — channels (WhatsApp, Instagram, Facebook, Website, Shopify)
  // are connected afterwards from Integrations.
  const handleSubmit = async () => {
    const name = formData.name.trim();
    if (!name) {
      setError("Workspace name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (mode === "create") {
        await dispatch(createWorkspace({ name })).unwrap();
      } else {
        await dispatch(updateWorkspace({ workspaceId: workspace._id, workspaceData: { name } })).unwrap();
      }
      toast.success(`Workspace "${name}" ${mode === "create" ? "created" : "updated"} successfully`);
      onClose();
    } catch (err) {
      setError(err || `Failed to ${mode === "create" ? "create" : "save"} workspace`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {mode === "create" ? "Create New Workspace" : "Edit Workspace"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          <TextField
            label="Workspace Name"
            value={formData.name}
            onChange={handleChange("name")}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !loading) handleSubmit();
            }}
            fullWidth
            required
            autoFocus
            disabled={loading}
          />

          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading || !formData.name.trim()}>
          {loading ? "Saving..." : mode === "create" ? "Create" : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkspaceDialog;
